import type {PublicMethodUtils} from '@wix/document-services-types'
import {environment} from '@wix/document-services-implementation'

export default function (publicMethodUtils: PublicMethodUtils) {
    return {
        methods: {
            env: {
                viewer: {
                    /**
                     * Returns the name of the viewer currently used by DS
                     */
                    getViewerName: publicMethodUtils.defineGetter(environment.getViewerName),

                    /**
                     * Returns the version of the viewer currently used by DS
                     */
                    getViewerVersion: publicMethodUtils.defineGetter(environment.getViewerVersion)
                },
                screen: {
                    getResolution: publicMethodUtils.defineGetter(environment.getScreenResolution)
                }
            }
        }
    }
}
